import styles from '../../style/styles/lightCircle.module.css';
import { useChatStateStore } from '../../zustand/store';

export const LightCircle = (props) => {
    const { type } = props;
    const { language } = useChatStateStore()    ;
    const ADMIN_MODE = language === 'ko' ? '관리자 모드' : 'Admin Mode';
    const USER_MODE = language === 'ko' ? '사용자 모드' : 'User Mode';

    const color = type === 'admin' ? 'green' : 'orange';
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <div className={`${styles[`lightCircle__${color}`]}`} />
            <p style={{ fontSize: 12, color: type === 'admin' ? 'rgba(116, 193, 116, 0.7)' : 'rgba(228, 150, 6, 0.7)', fontWeight: 700 }}>{type === 'admin' ? ADMIN_MODE : USER_MODE}</p>
        </div>
    );
};
